import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { ZeitenService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [ZeitenService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class ZeitenServiceModule {}
